module.exports = __webpack_public_path__ + "static/media/template3.fb626fe6.png";